import droneIcon from "./droneIcon.png";

export default {
  droneIcon,
};
